/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2020-06-04 15:40:08
 * @LastEditors: Jianyong Wang
 * @LastEditTime: 2021-11-01 14:43:04
 */
import user from './user'
import common from './common'

const api = {
  ...user,
  ...common
}

export default api
